<template>
  <b-card-body>
    <b-card 
      v-if="value !== null" 
      sub-title="Geselecteerde unit"
    >
      <h3>{{ unit.unitkenmerk }}</h3>
      <b-card-text>{{ unit.adres }} {{ unit.plaats }} </b-card-text>
      <b-button @click="$emit('unit-selected',null)">
        Kies andere unit
      </b-button>
    </b-card>

    <b-button-toolbar 
      v-if="value == null" 
      class="mb-3"
    >
      <b-button-group>
        <b-form-input 
          v-model="filter" 
          type="search" 
          placeholder="Zoeken..."
        />
      </b-button-group>
    </b-button-toolbar>

    <b-table 
      v-if="value == null" 
      :filter="filter"
      :fields="['unitkenmerk','adres','onderhoudsnummer','keuringsnummer','plaats']"
      :items="units"
      dark
      select-mode="single"
      selected-variant="primary"
      selectable
      hover
      fixed
      small
      bordered 
      striped
      @row-clicked="(row) => $emit('unit-selected', row.id)"
    />
  </b-card-body>
</template>
<script>
import Unit from './trajecten/Unit.vue'
import { serviceMixin } from "@/mixins/serviceMixin";
export default {
    name: 'UnitSelect',
    components: {Unit},
    mixins: [serviceMixin],
    props: {
        relatieId: {
          type: Number,
          default: null
        },
        value: {
          type: Number,
          default: null
        }
    },
    data() {
        return  {
            filter: null,
            display_mode: 'list',
            possible_modes: ['list','tiles'],
            units: []
        }
    },
    computed: {
      path: function () {
        return `/relaties/${this.relatieId}/units/select`
      },
      unit: function () {
        if (this.value == null) return
        if (this.units.filter(u => u.id === this.value).length == 0) return
        return this.units.filter(u => u.id === this.value)[0]
      }
    },
    watch: {},
    mounted () {
        this.getUnits()
    },
    methods: {
      getUnits() {
        console.log("getUnits");
        var vm = this;
        this.get(this.path).then(resp => vm.units = resp.data.units).catch((error) => console.log(error))
      }
    },
}
      
</script>